export const navigation = {
tabs: {
home: "Inicio",
assets: "Activos",
work: "Trabajo",
reports: "Informes",
contacts: "Contactos",
analytics: "Analítica",
account: "Cuenta",
},
planLapsed: {
member: "El plan de este espacio de trabajo ya no incluye Equipos. Puedes leerlo todo, pero no cambiarlo: pide al propietario del espacio que restablezca el plan.",
},
mobile: {
moreTab: "Más",
scanTab: "Escanear",
moreSubtitle: "El resto de tu espacio de trabajo y atajos.",
planLockedA11y: "{{label}}, no incluido en tu plan. Abre los planes que lo incluyen.",
overflowSection: "Accesos directos",
overflow: {
  sites: "Sitios",
contacts: "Contactos",
reports: "Informes",
analytics: "Analítica",
knowledge: "Conocimiento",
guide: "Ayuda",
assistant: "Asistente",
activity: "Actividad",
calendar: "Calendario",
checklists: "Listas de verificación",
groupRules: "Reglas de grupo",
compliance: "Cumplimiento",
inspections: "Inspecciones",
jobs: "Órdenes de trabajo",
people: "Personas",
profile: "Perfil",
},
},
stack: {
forgotPassword: "Olvidé mi contraseña",
setNewPassword: "Nueva contraseña",
newAsset: "Nuevo activo",
editAsset: "Editar activo",
addDocument: "Añadir documento",
renewDocument: "Renovar documento",
newChecklist: "Nueva lista de verificación",
newInspection: "Nueva inspección",
shareReport: "Enviar informe",
convertToJobs: "Crear órdenes de trabajo",
inspectionReview: "Revisión de inspección",
contractors: "Contratistas",
contractorHome: "Inicio contratista",
scheduleInspection: "Programar inspección",
scheduleDetails: "Detalles de la programación",
calendar: "Calendario",
teamManagement: "Gestión de equipo",
teamInvitation: "Invitación al equipo",
workspaceAiAudit: "Auditoría de IA y automatización",
workspaceBilling: "Facturación y uso",
contactInvitation: "Invitación de contacto",
asset: "Activo",
submitQuote: "Enviar presupuesto",
inviteOnly: "Solo por invitación",
privateRequest: "Solicitud privada",
quoteRequest: "Solicitud de presupuesto",
inspectionReport: "Informe de inspección",
checklist: "Lista de control",
quotes: "Presupuestos",
jobsCreated: "Trabajos creados",
reviewContact: "Revisar contacto",
reviewContactSub: "Editar y añadir roles",
inspectionComplete: "Inspección completada",
requestQuotes: "Solicitar presupuestos",
generateWithAI: "Generar con IA",
generateWithAISub: "Sugerir un borrador de lista de verificación",
generationFailed: "Error al generar",
reviewAssign: "Revisar y asignar",
reviewAssignListSub_one: "{{count}} trabajo · Definir la vía de trabajo y asignar",
reviewAssignListSub_other: "{{count}} trabajos · Definir la vía de trabajo y asignar",
importContacts: "Importar contactos",
importContactsSub: "¿Cómo quieres añadirlos?",
phonePicker: "Selector de teléfono",
phonePickerSub: "Un contacto por selección",
suggestedJobs: "Órdenes de trabajo de seguimiento",
saveWorkflowTemplate: "Guardar lista de control de flujo de trabajo",
sentForApproval: "Enviado para aprobación",
assetReadOnlyShared: "Solo lectura · Compartido contigo",
analytics: "Analítica",
analyticsScope: "Ámbito: {{label}}",
scheduledInspection: "Inspección programada",
scheduleFallback: "Programación",
sharedKnowledge: "Conocimiento compartido",
settings: "Ajustes",
help: "Ayuda",
preferences: "Preferencias",
deleteAccount: "Eliminar cuenta",
contact: "Contacto",
addContact: "Añadir contacto",
editContact: "Editar contacto",
contractorDirectory: "Directorio de contratistas",
importFromContacts: "Importar desde contactos",
addContractor: "Añadir contratista",
alreadyExists: "Ya existe",
updateContractor: "Actualizar contratista",
inspection: "Inspección",
job: "Orden de trabajo",
convertToJobsApproved_one: "{{count}} aprobado",
convertToJobsApproved_many: "{{count}} aprobados",
convertToJobsApproved_other: "{{count}} aprobados",
reviewAssignListSub_many: "{{count}} trabajos · Definir la vía de trabajo y asignar",
recurringJobCreate: "Nuevo plan de mantenimiento",
},
scopeChip: {
all: "Todo",
personal: "Personal",
teamNamed: "Equipo: {{name}}",
teamFallback: "Equipo",
modalTitle: "Ámbito",
cancel: "Cancelar",
a11y: "Filtro del espacio de trabajo, {{label}}",
},
shell: {
brandTitle: "AssetWRX",
brandSubtitle: "Plataforma de operaciones de activos",
navSection: "Navegación",
sectionOperate: "Operar",
sectionNetwork: "Red",
sectionInsights: "Analítica",
sectionAccount: "Cuenta",
brandHomeA11y: "Inicio de AssetWRX",
brandHomeWithWorkspaceA11y: "{{workspace}} · Inicio de AssetWRX",
collapseNav: "Contraer navegación",
expandNav: "Expandir navegación",
primaryNavA11y: "Navegación principal",
accountA11y: "Cuenta",
notificationsA11y: "Notificaciones",
skipToContent: "Saltar al contenido principal",
notificationsA11yUnread_one: "Notificaciones, {{count}} sin leer",
notificationsA11yUnread_many: "Notificaciones, {{count}} sin leer",
notificationsA11yUnread_other: "Notificaciones, {{count}} sin leer",
notificationsA11yUnreadMany: "Notificaciones, más de 99 sin leer",
activitySheetTitle: "Notificaciones",
activityUnreadSubtitle_one: "{{count}} sin leer",
activityUnreadSubtitle_many: "{{count}} sin leer",
activityUnreadSubtitle_other: "{{count}} sin leer",
activityUnreadSubtitleCapped: "Más de {{limit}} sin leer",
activityEmpty: "Aún no hay notificaciones",
activitySeeAll: "Ver toda la actividad",
accountRailA11y: "Secciones de configuración",
accountRailTitle: "Configuración",
accountRailSubtitle: "Cuenta personal, espacio de trabajo y administración",
sectionPersonal: "Tú",
sectionWorkspace: "Espacio de trabajo",
sectionTeam: "Equipo",
sectionAdmin: "Administración",
accountNavProfile: "Perfil",
accountNavPersonalDetails: "Detalles del perfil",
accountNavPreferences: "Preferencias",
accountNavHelp: "Ayuda",
accountNavWorkspaceOverview: "Resumen",
accountNavDefaults: "Valores por defecto",
accountNavOrganization: "Organización",
accountNavBranding: "Marca de los informes",
accountNavTeam: "Equipo e invitaciones",
accountNavBilling: "Facturación y uso",
accountNavIntegrations: "Integraciones",
accountNavSyncCenter: "Cambios sin enviar",
accountNavApiExplorer: "Explorador de API",
accountNavAudit: "Auditoría de IA y automatización",
accountNavTemplates: "Listas de control",
accountNavFeatures: "Funciones",
accountNavDiagnostics: "Diagnóstico",
accountNavAbout: "Acerca de",
accountNavIndustryPacks: "Paquetes por sector",
accountNavAssetTypes: "Tipos de activo",
accountNavAi: "Auditoría de uso de IA",
accountNavAssistantActivity: "Actividad del asistente",
accountNavPrivacy: "Privacidad",
accountNavBillingShort: "Facturación",
accountNavTeams: "Equipos",
accountNavSecurity: "Seguridad",
accountNavNotifications: "Notificaciones",
accountNavBrandingDefaults: "Marca y valores por defecto",
accountNavHandbook: "Manual de integración",
sectionAdvanced: "Avanzado",
railBackToSettings: "Todos los ajustes",
railAssistant: "Asistente",
railIntegrations: "Automatizaciones",
railBilling: "Facturación",
},
  // The header trail on detail screens: Site › Asset › work item › Report.
  trail: {
    sites: 'Sitios',
    site: 'Sitio',
    assets: 'Activos',
    asset: 'Activo',
    inspection: 'Inspección',
    job: 'Orden de trabajo',
    report: 'Informe',
    plan: 'Plan',
    document: 'Documento',
    contacts: 'Contactos',
    contact: 'Contacto',
  },
};
